import { useState } from "react";
import { QuestionaryType } from "../../models/QuestionaryType";
import { Button, Col, Form, Modal, Row, Stack, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBackwardStep,
    faBan,
    faBoxOpen,
    faForwardStep,
} from "@fortawesome/free-solid-svg-icons";
import ArchiveButton from "../../Helpers/archiveButton";

type Props = {
    onHide: () => void;
    show: boolean;
    questionaryType: QuestionaryType[] | null;
    onRestore: (questionaryType: QuestionaryType) => void;
};

const ModalArchiveQuestionaryTypes = (props: Props) => {
    const [filterText, setFilterText] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 8;

    const getFilteredArchivedQuestionaryTypes = () => {
        const search = filterText.toLowerCase();

        return (props.questionaryType ?? []).filter((qt) => {
            return (
                qt.isArchived === true &&
                (qt.name.toLowerCase().includes(search) ||
                    qt.id?.toString().includes(search))
            );
        });
    };

    const filteredData = getFilteredArchivedQuestionaryTypes();
    const totalPages = Math.ceil(filteredData.length / pageSize);

    const paginatedData = filteredData.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    return (
        <Modal
            show={props.show}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            onHide={props.onHide}
            size="xl"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Tipos de cuestionario archivados
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="mb-3 g-3 align-items-center">
                    <Col md={7}>
                        <Form.Control
                            type="text"
                            placeholder="Buscar..."
                            value={filterText}
                            onChange={(e) => setFilterText(e.target.value)}
                        />
                    </Col>
                </Row>
                {filteredData.length === 0 ? (
                    <p className="text-center" style={{ marginTop: 40 }}>
                        No se encontraron tipos de cuestionarios archivados.
                    </p>
                ) : (
                    <>
                        <Row>
                            <Col>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr className="text-center">
                                            <th>ID</th>
                                            <th>Descripción</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedData.map((qt) => (
                                            <tr key={qt.id}>
                                                <td className="text-center">
                                                    {qt.id}
                                                </td>
                                                <td>{qt.name}</td>
                                                <td className="text-center">
                                                    <Stack
                                                        direction="horizontal"
                                                        gap={2}
                                                        className="justify-content-center"
                                                    >
                                                        <ArchiveButton
                                                            title="Restaurar"
                                                            description="¿Estás seguro de que deseas restaurar este tipo de auditoría?"
                                                            iconButton={
                                                                faBoxOpen
                                                            }
                                                            variant="primary"
                                                            onClick={() => {
                                                                props.onRestore(
                                                                    qt
                                                                );
                                                                setFilterText(
                                                                    ""
                                                                );
                                                                props.onHide();
                                                            }}
                                                        />
                                                    </Stack>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        {/* Controles de paginación */}
                        <Row className="mt-1">
                            <Col className="d-flex justify-content-end align-items-center gap-2">
                                <Button
                                    variant={
                                        currentPage === 1
                                            ? "secondary"
                                            : "primary"
                                    }
                                    disabled={currentPage === 1}
                                    onClick={() => setCurrentPage((p) => p - 1)}
                                    size="sm"
                                >
                                    <FontAwesomeIcon icon={faBackwardStep} />
                                </Button>
                                <span>
                                    Página {currentPage} de {totalPages}
                                </span>
                                <Button
                                    variant={
                                        currentPage === totalPages
                                            ? "secondary"
                                            : "primary"
                                    }
                                    disabled={currentPage === totalPages}
                                    onClick={() => setCurrentPage((p) => p + 1)}
                                    size="sm"
                                >
                                    <FontAwesomeIcon icon={faForwardStep} />
                                </Button>
                            </Col>
                        </Row>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={() => {
                        props.onHide();
                    }}
                >
                    <FontAwesomeIcon
                        icon={faBan}
                        style={{ paddingRight: "3px" }}
                    />
                    <span className="ms-2">Cancelar</span>
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalArchiveQuestionaryTypes;
